import React from "react";
import { Row, Col } from 'react-bootstrap';
import SectionContainer from '../containers/section-container';
import FeatureCounterRow from '../features/featureCounter-row'
import Heading2Paragraph from '../titles/heading2-paragraph';
import GenericParagraph from '../paragraphs/Paragraph.jsx';
import Carousel from '../carousel/owlCarousel';
import VisibilitySensor from 'react-visibility-sensor';

export default class CounterFeature extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            animated : false,
            animationClasses : ['text-center'],
        };
        this.headerVisible = this.headerVisible.bind(this);
    }

    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var classes = this.state.animationClasses;
                classes.push('fadeInUp');
                classes.push('animated-fast');
                this.setState({ animated: true, animationClasses: classes });
            }
        }
    };
    render() {
        return (
            <SectionContainer>
                <Row>
                    <Heading2Paragraph content={ this.props.content } />
                    <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible }>
                        <Col className={ this.state.animationClasses.join(' ') } style={ { opacity : 0 } } md={12}>
                            <GenericParagraph text={ this.props.text }/>
                        </Col>
                    </VisibilitySensor>
                </Row>
                <FeatureCounterRow featureRowItems={ this.props.featureRowItems } />
                <Carousel items={ this.props.items } />
            </SectionContainer>               
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/features/counter-feature.js